module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'controller',
        'controller',
    ],

    config: {
        tabConfigNavKey: 'absence',
    },

    methods: {},
}